import React from "react";

const IconPasswordVisible = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2502 13.3334L14.1875 10.5032"
        stroke="#0F1319"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 14.5834V11.6667"
        stroke="#0F1319"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.75 13.3334L5.80746 10.5103"
        stroke="#0F1319"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.5 6.66663C5.5 13.3333 14.5 13.3333 17.5 6.66663"
        stroke="#0F1319"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default IconPasswordVisible;
